import { User } from "../models/users/user";
import { httpPost } from "./http";

const apiUrl = 'api/users';

export const getAccessToken = (user: User) => httpPost<string>(`${apiUrl}/getaccesstoken`, user);
export const resetPassword = (user: User) => httpPost<boolean>(`${apiUrl}/resetpassword`, user);
export const changePassword = (user: User) => httpPost<boolean>(`${apiUrl}/changepassword`, user);
